module.exports = __webpack_public_path__ + "static/media/badge-modal-close.6f55468f.svg";